<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-date-picker v-model="create_time" type="daterange" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="商品ID" v-model="item_id" size="mini"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="订单号" v-model="order_id" size="mini"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
        </el-col>
        <el-col :span="3">
          <el-select v-model="rate_status" @change="rateStatusSelectHandle" placeholder="是否评价"
                     style="width: 100%;" size="mini">
            <el-option
                    v-for="(item, index) in rateStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-table :data="list" style="width: 100%" :height="wheight-140" v-loading="loading" element-loading-text="数据加载中">
        <el-table-column prop="star" width="150" label="评价星级">
          <template  slot-scope="scope">
            <div class="block" v-if="scope.row.parent_id == '0'">
              <el-rate disabled  v-model="scope.row.star"></el-rate>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content"  label="评价内容"></el-table-column>
        <el-table-column prop="order_id" label="订单号"></el-table-column>
        <el-table-column prop="item_name" label="商品信息"></el-table-column>
        <el-table-column prop="username" width="100" label="评价人"></el-table-column>
        <el-table-column prop="is_reply" width="160" label="评价状态">
          <template slot-scope="scope">
            <!-- 订单状态 -->
            <span  v-if="scope.row.parent_id == '0'">
             <el-tag v-if="scope.row.is_reply" type="success" size="mini">已回复</el-tag>
            <el-tag v-else type="danger" size="mini">未回复</el-tag>
            </span>
            <el-tag type="danger" v-if="scope.row.disabled" size="mini" >已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created" width="160" label="评价时间">
          <template slot-scope="scope">
            <span>{{scope.row.created | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button  type="text" v-if="scope.row.parent_id == '0'" @click="detailsDialog(scope.row)">详情</el-button>
            <el-button  type="text" v-if="scope.row.is_reply=== false" @click="replyDialog(scope.row)">回复</el-button>
            <el-button  type="text" v-if="scope.row.disabled=== false" @click="rateDelete(scope.row.rate_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10,20,50]"
          :total="total_count"
          :page-size="params.pageSize">
        </el-pagination>
      </div>
      <el-dialog title="评价回复" :visible.sync="replyDialogVisible" width="35%" :before-close="handleClose">
        <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="form.content">
        </el-input>
        <span slot="footer" class="dialog-footer">
    <el-button @click="replyDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="replySubmit">确 定</el-button>
  </span>
      </el-dialog>

      <el-dialog title="评价详情" width="45%" :visible.sync="detailsDialogVisible"  :before-close="handleClose">
        <el-dialog
                width="35%"
                :visible.sync="imgVisible"
                append-to-body>
          <img width="100%" :src="Dialogpic"/>
        </el-dialog>
        <div class="section-white">
          <div class="section-header with-border">
            <h3>评价商品信息</h3>
          </div>
          <div class="section-body">
            <el-row>
                <el-table :data="details.itemInfo" style="width: 100%">
                  <el-table-column class="goods-img" prop="pic" label="商品图片" >
                    <template slot-scope="scope">
                      <img :src="scope.row.pics[0]" :alt="scope.row.item_name" width="100"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="item_name" label="商品名称" width="180">
                  </el-table-column>
                  <el-table-column  label="成交价格(元)">
                    <template slot-scope="scope"><span>￥{{scope.row.total_fee / 100}}</span></template>
                  </el-table-column>
                </el-table>
            </el-row>
          </div>
          <div class="section-header with-border">
            <h3>评价信息</h3>
          </div>
          <div class="section-body">
            <el-row>
              <el-col :span="3" class="col-3 content-right">评价星级：</el-col>
              <el-col :span="20">
                  <el-rate disabled  v-model="details.rateInfo.star"></el-rate>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">评价内容：</el-col>
              <el-col :span="20">{{details.rateInfo.content}}</el-col>
            </el-row> <el-row>
              <el-col :span="3" class="col-3 content-right">评价图：</el-col>
              <el-col :span="20" v-if="details.rateInfo.rate_pic">

                  <img v-for="pic in details.rateInfo.rate_pic"  :src="pic" width="100" @click="showImg(pic)"/>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">评价人：</el-col>
              <el-col :span="20">{{details.rateInfo.username}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">评价时间：</el-col>
              <el-col :span="20">{{details.rateInfo.created | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">是否回复：</el-col>
              <el-col :span="20">
                <el-tag v-if="details.rateInfo.is_reply" type="success" size="mini">已回复</el-tag>
                <el-tag v-else type="danger" size="mini">未回复</el-tag>
              </el-col>
            </el-row>
          </div>
          <div class="section-header with-border">
            <h3>管理员回复信息</h3>
          </div>
          <div class="section-body" v-if="details.replyInfo">
            <el-row>
              <el-col :span="3" class="col-3 content-right">回复内容：</el-col>
              <el-col :span="20">
                <el-tag type="success" >
                  {{details.replyInfo.content}}
                </el-tag>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">回复人：</el-col>
              <el-col :span="20" >{{details.replyInfo.operator_name}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="col-3 content-right">回复时间：</el-col>
              <el-col :span="20">{{details.replyInfo.created | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
            </el-row>
          </div>
          <div class="section-header with-border">
            <h3>买家评论</h3>
          </div>
          <div class="section-body">
            <div class="block" v-if="details.userReply">
              <el-timeline v-for="(reply, index) in details.userReply" :key="index">
                <el-timeline-item :timestamp="reply.created | datetime('yyyy-MM-dd hh:mm:ss')"  placement="top">
                  <el-card>
                    <h4>{{reply.username}}：{{reply.content}}</h4>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="reply.parent.role=='seller'">管理员</span> {{reply.parent.username}} ：&nbsp;&nbsp;<span>“{{reply.parent.content}}”</span></p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>
<style scoped lang="scss" type="text/css">

  img {
    margin-right: 5px;
  }
</style>
<script>
  import { mapGetters } from 'vuex'
  import { getTradeRateList, replyTradeRate, getTradeRateDetails, deleteRate} from '../../../../api/trade'
  export default {
    data () {
      return {
        loading: false,
        create_time: '',
        form: {
          rate_id: '',
          content: ''
        },
        params: {
          page: 1,
          pageSize: 20
        },
        rateStatusList: [
          {name: '未回复', value: '0'},
          {name: '已回复', value: '1'}
        ],
        rate_status: '',
        item_id: '',
        time_start_begin: '',
        time_start_end: '',
        total_count: 0,
        list: [],
        order_id: '',
        Dialogpic: '',
        details: {
          rateInfo: [],
          itemInfo: [],
          userReply: []
        },
        replyDialogVisible: false,
        imgVisible: false,
        detailsDialogVisible: false
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      rateDelete (id) {
        const _self = this
        this.$confirm('确认删除当前评价吗？').then(_ => {
          deleteRate(id).then(res => {
            if (res.data.data.status) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              _self.getTradeRateList(this.params)
            }
          })
        })
      },
      showImg (pic) {
        this.imgVisible = true
        this.Dialogpic = pic
      },
      handleClose () {
        this.replyDialogVisible = false
        this.detailsDialogVisible = false
      },
      replyDialog (row) {
        this.form.rate_id = row.rate_id
        this.replyDialogVisible = true
      },
      replySubmit () {
        replyTradeRate(this.form).then(res => {
          this.$message({
            type: 'success',
            message: '回复成功'
          })
          this.replyDialogVisible = false
          this.getTradeRateList(this.params)
        })
      },
      detailsDialog (row) {
        getTradeRateDetails(row.rate_id).then(res => {
          this.details = res.data.data
        })
        this.detailsDialogVisible = true
      },
      rateStatusSelectHandle () {
        this.params.rate_status = this.rate_status
        this.params.page = 1
        this.getParams()
        this.getTradeRateList(this.params)
      },
      search (e) {
        this.params.page = 1
        this.getParams()
        this.getTradeRateList(this.params)
      },
      dateChange (val) {
        if (val.length > 0) {
          this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.time_start_begin = ''
          this.time_start_end = ''
        }
        this.params.page = 1
        this.getParams()
        this.getTradeRateList(this.params)
      },
      handleCurrentChange (val) {
        this.params.page = val
        this.loading = false
        this.getParams()
        this.getTradeRateList(this.params)
      },
      handleSizeChange (pageSize) {
        this.loading = false
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getParams()
        this.getTradeRateList(this.params)
      },
      getParams () {
        this.params.time_start_begin = this.time_start_begin
        this.params.time_start_end = this.time_start_end
        this.params.item_id = this.item_id
        this.params.order_id = this.order_id
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      getTradeRateList (filter) {
        this.loading = true
        getTradeRateList(filter).then(response => {
          this.list = response.data.data.list
          this.total_count = Number(response.data.data.total_count)
          this.loading = false
        })
      }
    },
    mounted () {
      this.getTradeRateList(this.params)
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?7ce68fce